{
  "id": "campaign-047",
  "name": "Crooked Pasture",
  "seed": "campaign:47",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "RRRRRR......",
    "RRRRRR......",
    "______......",
    ".....y..T...",
    "...vv..c..~~",
    "...vv..cx...",
    "...vv..c.K..",
    "...vv.T.....",
    "..y.u.......",
    ".....e......",
    "fff..fffffff",
    ".....e......",
    ".....e.x....",
    "....y.......",
    "........#...",
    "S..........."
  ],
  "critters": [
    {
      "kind": "dog",
      "x": 9,
      "y": 7
    },
    {
      "kind": "rabbit",
      "x": 5,
      "y": 15
    },
    {
      "kind": "rabbit",
      "x": 2,
      "y": 4
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 3,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 7
    }
  ],
  "generatorVersion": 3,
  "level": 47,
  "biome": "farm",
  "par": {
    "reel": 6173,
    "push": 5191,
    "selfPropelled": 4932,
    "tractor": 4360,
    "zeroTurn": 3296,
    "fairway": 2059
  },
  "routeTries": {
    "par": {
      "reel": 17,
      "push": 2,
      "selfPropelled": 0,
      "tractor": 21,
      "zeroTurn": 0,
      "fairway": 5
    }
  }
}
